import React, {useEffect} from "react";
import "./DailyBlogsPage.scss";
import {useLocation, useParams} from "react-router-dom";
import Blog5 from "./DailyBlogs/Blog5";
import Blog6 from "./DailyBlogs/Blog6";
import Blog7 from "./DailyBlogs/Blog7";
import Blog8 from "./DailyBlogs/Blog8";
import Blog9 from "./DailyBlogs/Blog9";
import Blog10 from "./DailyBlogs/Blog10";
import Blog11 from "./DailyBlogs/Blog11";
import Blog12 from "./DailyBlogs/Blog12";
import Blog13 from "./DailyBlogs/Blog13";
import Blog14 from "./DailyBlogs/Blog14";
import Blog15 from "./DailyBlogs/Blog15";
import Blog16 from "./DailyBlogs/Blog16";
import Blog17 from "./DailyBlogs/Blog17";
import Blog18 from "./DailyBlogs/Blog18";
import Blog19 from "./DailyBlogs/Blog19";
import Blog20 from "./DailyBlogs/Blog20";
import Blog21 from "./DailyBlogs/Blog21";
import Blog22 from "./DailyBlogs/Blog22";
import Blog23 from "./DailyBlogs/Blog23";
import Blog24 from "./DailyBlogs/Blog24";
import Blog25 from "./DailyBlogs/Blog25";
import Blog26 from "./DailyBlogs/Blog26";
import Blog27 from "./DailyBlogs/Blog27";
import Blog28 from "./DailyBlogs/Blog28";
import Blog29 from "./DailyBlogs/Blog29";
import Blog30 from "./DailyBlogs/Blog30";
import Blog31 from "./DailyBlogs/Blog31";
import Blog32 from "./DailyBlogs/Blog32";
import Blog33 from "./DailyBlogs/Blog33";
import Blog34 from "./DailyBlogs/Blog34";
import Blog35 from "./DailyBlogs/Blog35";
import Blog36 from "./DailyBlogs/Blog36";
import Blog37 from "./DailyBlogs/Blog37";

const DailyBlogsPage = () => {
  const {blogId} = useParams();
  console.log(blogId, "blogIdblogId");
  useEffect(() => {}, []);
  return (
    <div className="dailyBlogsPageContainer">
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 5 && <Blog5 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 6 && <Blog6 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 7 && <Blog7 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 8 && <Blog8 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 9 && <Blog9 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 10 && <Blog10 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 11 && <Blog11 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 12 && <Blog12 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 13 && <Blog13 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 14 && <Blog14 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 15 && <Blog15 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 16 && <Blog16 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 17 && <Blog17 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 18 && <Blog18 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 19 && <Blog19 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 20 && <Blog20 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 21 && <Blog21 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 22 && <Blog22 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 23 && <Blog23 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 24 && <Blog24 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 25 && <Blog25 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 26 && <Blog26 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 27 && <Blog27 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 28 && <Blog28 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 29 && <Blog29 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 30 && <Blog30 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 31 && <Blog31 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 32 && <Blog32 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 33 && <Blog33 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 34 && <Blog34 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 35 && <Blog35 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 36 && <Blog36 />}</div>
      <div className="dailyBlogsPageWrapper">{Number(blogId) === 37 && <Blog37 />}</div>
    </div>
  );
};

export default DailyBlogsPage;
